/**
 * Dev-only logger.
 *
 * In development every call falls through to `console` so we still get useful
 * output while coding and running tests. Production builds (CRA sets
 * `process.env.NODE_ENV === 'production'`) silently drop every call so we
 * don't leak internal state, stack traces or PII to end-users' devtools.
 *
 * If we ever bolt on Sentry / LogRocket / whatever, this is the one file to
 * update — swap the prod branch to forward to that service and every call
 * site benefits automatically.
 *
 * Usage:
 *   import { logger } from '@/utils/logger';
 *   logger.error('load failed', err);
 */
const isProd = process.env.NODE_ENV === 'production';
const noop = () => {};

export const logger = {
  log:   isProd ? noop : (...args) => console.log(...args),   // eslint-disable-line no-console
  warn:  isProd ? noop : (...args) => console.warn(...args),  // eslint-disable-line no-console
  error: isProd ? noop : (...args) => console.error(...args), // eslint-disable-line no-console
  info:  isProd ? noop : (...args) => console.info(...args),  // eslint-disable-line no-console
  debug: isProd ? noop : (...args) => console.debug(...args), // eslint-disable-line no-console
};

export default logger;
